import React from 'react'
import Box from '@mui/material/Box'
import Text from '../../components/Text'
import Input from '../../components/Input/Input'
import Button from '../../components/Button/Button'
import { useUiStore } from '../../stores/uiStore'

type AddResultModalProps = {
  onCreateResult: (label: string) => void
  defaultLabel?: string
  isLoading?: boolean
  placeholder?: string
}

const AddResultModal = ({ onCreateResult, defaultLabel, isLoading, placeholder }: AddResultModalProps) => {
  const { cancelDialog } = useUiStore()
  const [label, setLabel] = React.useState(defaultLabel || '')
  const [error, setError] = React.useState('')

  const onSubmit = () => {
    const value = label.trim()
    if (!value) {
      setError('Label is required')
      return
    }
    onCreateResult(value)
  }

  return (
    <Box minWidth={300} px={3} py={2}>
      <Text variant="medium" weight="bold" useDiv mb={1}>
        Add New Result
      </Text>
      <Input
        fullWidth
        value={label}
        placeholder={placeholder || 'Result label (e.g. Game 1)'}
        onChange={(e) => {
          setLabel(e.target.value)
          if (error) setError('')
        }}
        error={!!error}
        helperText={error}
      />
      <Box mt={2} display="flex" justifyContent="flex-end" columnGap={1}>
        <Button variant="outlined" size="small" onClick={cancelDialog} disabled={!!isLoading}>
          Cancel
        </Button>
        <Button variant="contained" size="small" onClick={onSubmit} loading={isLoading}>
          Create result
        </Button>
      </Box>
    </Box>
  )
}

export default AddResultModal

